import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import Footer from './Footer';

function Landing() {
  return (
    <div className="App" style={{ paddingBottom: '140px' }}>
      <header className="App-header" style={{ paddingBottom: '2em' }}>
        <h1 style={{ color: 'var(--color-green-primary)', fontSize: '3.5rem', marginBottom: '1rem' }}>🌱 Canopy Biosystems</h1>
        <h2 style={{ color: 'var(--color-text-secondary)', fontSize: '2rem', marginBottom: '2rem', textAlign: 'left', paddingLeft: '2.8rem' }}>Keep Your Plants Alive</h2>
        
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center', lineHeight: '1.8' }}>
          <p style={{ fontSize: '1.2rem', color: 'var(--color-text-primary)', marginBottom: '2rem' }}>
            Real-time plant health monitoring with precision dendrometer sensors. Take the guesswork out of watering your plants!
          </p>
          
          <div style={{ marginBottom: '3rem' }}>
            <Link 
              to="/dashboard" 
              style={{
                display: 'inline-block',
                padding: '1em 2.5em',
                background: 'var(--color-green-primary)',
                color: 'white',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                borderRadius: '8px',
                textDecoration: 'none',
                marginRight: '1em'
              }}
            >
              View Dashboard
            </Link>
          </div>

          <section style={{ marginBottom: '3rem' }}>
            <h3 style={{ color: 'var(--color-green-primary)', fontSize: '1.8rem', marginBottom: '1rem' }}>Why Canopy?</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
              <div style={{ padding: '1.5rem', background: 'rgba(212, 165, 116, 0.1)', borderRadius: '8px' }}>
                <h4 style={{ color: 'var(--color-green-primary)' }}>Precise Monitoring</h4>
                <p>Advanced dendrometer sensors measure your plant directly to detect subtle changes in plant health before visible symptoms appear.</p>
              </div>
              <div style={{ padding: '1.5rem', background: 'rgba(212, 165, 116, 0.1)', borderRadius: '8px' }}>
                <h4 style={{ color: 'var(--color-green-primary)' }}>Real-Time Alerts</h4>
                <p>Get instant notifications when your plants need attention. Never guess about watering schedules again.</p>
              </div>
              <div style={{ padding: '1.5rem', background: 'rgba(212, 165, 116, 0.1)', borderRadius: '8px' }}>
                <h4 style={{ color: 'var(--color-green-primary)' }}>Data-Driven Insights</h4>
                <p>Visualize plant health trends over time. Understand what conditions help your plants thrive.</p>
              </div>
            </div>
          </section>

          <section>
            <h3 style={{ color: 'var(--color-green-primary)', fontSize: '1.8rem', marginBottom: '1rem' }}>Getting Started</h3>
            <p style={{ marginBottom: '1rem' }}>
              Set up your Canopy sensor with our easy installation guide and start monitoring your plants today.
            </p>
            <Link 
              to="/clip-install" 
              style={{
                color: 'var(--color-green-primary)',
                textDecoration: 'none',
                fontWeight: 'bold',
                fontSize: '1.1rem'
              }}
            >
              View Installation Guide →
            </Link>
          </section>
        </div>
      </header>

      <Footer />
    </div>
  );
}

export default Landing;
